// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import ResidentialDetailsActionType from './residential-details.types';
import {
	residentialDetailsAddSuccess,
	residentialDetailsAddFailure,
	residentialDetailsAddUserResponseChanged,
} from './residential-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { residentialMemberDetailsAdd } from './residential-details.service';

/** ***************** Residential Address Add Start ************************/
export function* AddResidentialDetails({ payload }: any) {
	try {
		const key = 'AddMemberResidentialDetails';
		const {
			companyID,
			databaseName,
			memberID,
			pincode,
			doorNo,
			addressStreet,
			country,
			state,
			district,
			city,
			village,
			userID,
			postOffice,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberPincode: pincode,
			MemberDoorNo: doorNo,
			MemberAddressStreet: addressStreet,
			MemberCountry: country,
			MemberState: state,
			MemberDistrict: district,
			MemberCity: city,
			MemberVillage: village,
			OfficerID: userID,
			Secratekey: key,
			MemberPostOffice: postOffice,
		};

		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(residentialMemberDetailsAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(residentialDetailsAddFailure(responseData.data));
		} else {
			yield put(residentialDetailsAddSuccess(responseData.data));
		}
	} catch (error) {
		yield put(residentialDetailsAddFailure(error));
	}
}

export function* AddResidentialDetailsResponseClear() {
	yield put(residentialDetailsAddUserResponseChanged());
}

export function* onResidentialDetailsAddStart() {
	yield takeLatest(
		ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_START,
		AddResidentialDetails,
	);
}

export function* onResidentialDetailsAddResponseRest() {
	yield takeLatest(
		ResidentialDetailsActionType.RESIDENTIAL_DETAILS_ADD_RESPONSE_REST_START,
		AddResidentialDetailsResponseClear,
	);
}
/** ***************** Residential Address Add End ************************/

export function* residentialDetailsSaga() {
	yield all([call(onResidentialDetailsAddStart), call(onResidentialDetailsAddResponseRest)]);
}
